module.exports = __webpack_public_path__ + "img/light-bulb.f05118f4.svg";